module.exports = __webpack_public_path__ + "static/media/soviet_bridge_building.301422e8.jpg";